import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, getTrackByFn, InputObservable } from '@y42/angular/util';
import { ColumnTypeEnum } from '@y42/json-schema';
import { map, Observable } from 'rxjs';
import { ColumnTypeAndLabel, Field, SourceTable } from './target-column.models';

@UntilDestroy()
@Component({
  selector: 'y42-target-column',
  templateUrl: './target-column.component.html',
  styleUrls: ['./target-column.component.scss'],
})
export class TargetColumnComponent {
  @Input() allowedColumnPattern = '';
  @Input() formGroup?: UntypedFormGroup;
  @Input() sourceTable?: SourceTable | null;
  @Input() formName = '';
  @Input() maxLength = 100;

  @Input()
  @InputObservable()
  allowedOutputTypes: ColumnTypeEnum[] = [
    ColumnTypeEnum.Numeric,
    ColumnTypeEnum.String,
    ColumnTypeEnum.Boolean,
    ColumnTypeEnum.Date,
    ColumnTypeEnum.Datetime,
    ColumnTypeEnum.Timestamp,
  ];
  allowedOutputTypes$!: Observable<ColumnTypeEnum[]>;

  @Input() outputTypeName = '';
  @Input() isFlatDisplay = false;
  @Input() selectedOutputType = '';
  @Input() label = 'Target Column';
  @Output() outputTypeChanged: EventEmitter<ColumnTypeEnum> = new EventEmitter();

  public readonly state = connectState(this, {
    allowedOutputTypes: this.allowedOutputTypes$.pipe(
      map((allowedOutputTypes) =>
        allowedOutputTypes.map((allowedOutputType) => {
          return {
            type: allowedOutputType,
            label: allowedOutputType.toLowerCase(),
          } as ColumnTypeAndLabel;
        }),
      ),
    ),
  });

  public readonly trackByType = getTrackByFn<ColumnTypeAndLabel>('type');

  COLUMN_NAME_NOT_ALLOWED = `Uppercase and special characters other than '_' are not allowed - can also not start with a special character`; // TODO:
  DUPLICATE = 'Duplicate name - this column already exists'; // TODO:

  onOutputTypeSelected(selectedType: ColumnTypeEnum) {
    this.formGroup?.get(this.outputTypeName)?.setValue(selectedType);
    this.outputTypeChanged.emit(selectedType);
  }

  trackByFieldName: TrackByFunction<Field> = (index: number, field: Field) => field.field_name;
}
